"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileType = getFileType;
var _magicBytes = _interopRequireDefault(require("magic-bytes.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
async function getFileType(file) {
  const buffer = await file.arrayBuffer();
  const [t, ...rest] = (0, _magicBytes.default)(new Uint8ClampedArray(buffer));
  return {
    mime: t.mime || 'application/octet-stream',
    extension: t.extension,
    typename: t.typename
  };
}